import styled from 'styled-components';
import { MEDIA_QUERY } from '@optimus-web/breakpoints';
import { getSpacingToken, getToken } from '@optimus-web/common';

export const NAVBAR_HEIGHT = 60;

const Navbar = styled.nav`
    background-color: ${getToken('backgroundStaticRaised')};
    border-bottom: 1px solid ${getToken('borderStaticSecondary')};
    display: flex;
    justify-content: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: ${getSpacingToken('100')}px 0;
    min-height: ${NAVBAR_HEIGHT}px;

    ${MEDIA_QUERY.tabletUp} {
        padding: ${getSpacingToken('100')}px;
    }
`;

export default Navbar;
